import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["readonly"]
const _hoisted_2 = { class: "d-flex flex-direction-row justify-content-start gap-2 flex-wrap flex-fill" }
const _hoisted_3 = ["disabled", "onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "dropdown align-self-center" }
const _hoisted_7 = ["id", "disabled"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["aria-labelledby"]
const _hoisted_11 = ["onClick", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "form-control d-flex flex-direction-row",
    ref: "root",
    readonly: _ctx.disabled ? '' : null
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedItems, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "btn-group btn-group-sm position-static",
          key: _ctx.optionsByValue.get(item) != null ? _ctx.getKey(_ctx.optionsByValue.get(item)) : item.toString()
        }, [
          (_ctx.optionsByValue.get(item) != null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["btn btn-secondary position-static", {
                    'disabled': _ctx.disabled,
                    }])
                }, [
                  _renderSlot(_ctx.$slots, "item", {
                    item: _ctx.optionsByValue.get(item),
                    main: true
                  }, () => [
                    _createTextVNode(_toDisplayString(_ctx.getLabel(_ctx.optionsByValue.get(item))), 1)
                  ])
                ], 2),
                _createElementVNode("button", {
                  disabled: _ctx.disabled ? '' : null,
                  type: "button",
                  class: "btn btn-secondary position-static",
                  onClick: ($event: any) => (_ctx.remove(index))
                }, _hoisted_5, 8, _hoisted_3)
              ], 64))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        ref: "dropdownToggle",
        id: _ctx.$id('dropdown-button'),
        type: "button",
        class: "btn btn-sm btn-outline-secondary",
        "data-bs-toggle": "dropdown",
        "aria-expanded": "false",
        disabled: _ctx.trueOptions.length == 0 || this.disabled ? '' : null
      }, _hoisted_9, 8, _hoisted_7),
      _renderSlot(_ctx.$slots, "dropdown", {
        buttonId: _ctx.$id('dropdown-button'),
        add: _ctx.add,
        options: _ctx.trueOptions
      }, () => [
        _createElementVNode("ul", {
          class: "dropdown-menu",
          "aria-labelledby": _ctx.$id('dropdown-button')
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trueOptions, (option) => {
            return (_openBlock(), _createElementBlock("li", {
              key: _ctx.getKey(option)
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "dropdown-item",
                onClick: ($event: any) => (_ctx.add(option)),
                disabled: _ctx.disabled
              }, [
                _renderSlot(_ctx.$slots, "item", {
                  item: option,
                  main: false
                }, () => [
                  _createTextVNode(_toDisplayString(_ctx.getLabel(option)), 1)
                ])
              ], 8, _hoisted_11)
            ]))
          }), 128))
        ], 8, _hoisted_10)
      ])
    ])
  ], 8, _hoisted_1))
}